<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">礼包内容</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 20px">
            <el-button type="primary" @click="batchSetting" v-if="this.show_batch_button">批量设置礼包内容</el-button>
            <el-button type="primary" @click="singleSetting" v-if="!this.show_batch_button">设置礼包内容</el-button>
            <el-button type="success" @click="add" style="">添加</el-button>
            <a class="download" :href="downloadFileUrl" download="" title="下载"><el-button type="warning" style="margin: 10px" v-if="this.show_batch_button">下载模板</el-button></a>
            <el-upload class="filter-item-upload" :headers="header" :action="serverFileUrl" :on-success="importFaq" :data="uploadData" :show-file-list="false" v-if="this.show_batch_button">
              <el-button type="warning" style="margin-top: -2px" v-if="this.show_batch_button">点击上传</el-button>
            </el-upload>
          </div>
        </div>
        <div>
          <el-table border v-loading="listLoading" :data="formData" ref="multipleTable" @selection-change="handleSelectionChange" style="width: 100%" min-height="200" max-height="1000">
            <el-table-column type="selection" width="40" v-if="this.show_batch_button" />
            <el-table-column prop="content" label="礼包内容" />
            <el-table-column prop="code" label=" 礼包码" />
          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getGiftCodeList" />

          <el-dialog :title="title" width="40%" center :visible.sync="batchSettingShow">
            <el-form style="margin-left: 20px">
              <el-form-item label="礼包内容" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input v-model="giftContent"></el-input>
                </el-col>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button @click="rmoveSetting">取 消</el-button>
              <el-button type="primary" @click="sureSetting">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog title="添加" width="40%" center :visible.sync="addShow">
            <el-form style="margin-left: 40px">
              <el-form-item label="礼包码" :label-width="formInputWidth">
                <el-col :span="16">
                  <el-input v-model="giftCode" style="width: 216px; margin-right: 20px"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeAdd">取 消</el-button>
              <el-button type="primary" @click="sureAdd">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { getGiftCodeListApi, addGiftCodeApi, updateLostGiftCodeApi } from '@/api/gift_bag.js';
import '@/assets/css/global.css';
import Pagination from '@/components/pagination/index';

export default {
  components: { Pagination },
  data() {
    return {
      listQuery: {
        template_id: '',
        page: 1,
        limit: 10,
      },
      formData: [],
      multipleSelection: [],
      giftCode: '',
      giftContent: '',
      show_batch_button: '',
      batchSettingShow: false,
      title: '',

      addShow: false,
      codeID: '',
      listLoading: false,
      total: 0,
      formInputWidth: '200px',
      downloadFileUrl: BASE_API + 'code_excel_download',
      serverFileUrl: BASE_API + 'admin/upload_comfort_code',
      header: {
        // token: sessionStorage.token
        Authorization: 'Bearer ' + getToken(),
      }, // 有的图片服务器要求请求头需要有toke
      uploadData: {
        template_id: 0,
      },
    };
  },
  created() {
    let item = JSON.parse(this.$route.query.data);
    this.listQuery.template_id = item.id;
    this.uploadData.template_id = Number(item.id);
    this.getGiftCodeList();
  },
  methods: {
    batchSetting() {
      if (this.multipleSelection == '') {
        this.$message.error('请先选择礼包');
        return;
      }
      this.giftContent = '';
      this.batchSettingShow = true;
    },
    singleSetting() {
      if (this.formData.length == 0) {
        this.$message.error('请先设置礼包码');
        return;
      }
      this.giftContent = '';
      this.batchSettingShow = true;
    },
    rmoveSetting() {
      (this.giftContent = ''), (this.batchSettingShow = false);
    },
    sureSetting() {
      let data = {
        ids: [],
        content: '',
      };
      if (!this.show_batch_button) {
        data.ids.push(this.formData[0].id);
      }
      data.content = this.giftContent;
      for (let item of this.multipleSelection) {
        data.ids.push(item.id);
      }
      updateLostGiftCodeApi(data)
        .then((response) => {
          console.log(response);
          this.batchSettingShow = false;
          this.multipleSelection = [];
          this.getGiftCodeList();
          this.$message.success(response.data.message);
        })
        .catch((error) => {
          this.batchSettingShow = false;
          this.$message.error(response.data.message);
        });
    },

    add() {
      this.giftCode = '';
      this.addShow = true;
    },
    removeAdd() {
      this.addShow = false;
    },
    sureAdd() {
      let data = {
        template_id: '',
        code: '',
      };
      data.template_id = this.listQuery.template_id;
      data.code = this.giftCode;
      addGiftCodeApi(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.getGiftCodeList();
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
      this.addShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    getGiftCodeList() {
      this.listLoading = true;
      getGiftCodeListApi(this.listQuery)
        .then((response) => {
          this.formData = response.data.data.data;
          this.total = response.data.data.total;
          this.show_batch_button = response.data.data.show_batch_button;
          this.codeID = response.data.data[0].id;
          if (this.show_batch_button == true) {
            this.title = '批量设置礼包内容';
          } else {
            this.title = '设置礼包内容';
          }
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    importFaq(res, file) {
      if (res.code != 200) {
        this.$message.error(res.message);
        // 如果code是2 说明是部分成功 那就下载错误文件
        if (201 == res.code || 202 == res.code) {
          window.open(BASE_API + 'admin/downloadErrorLog');
        }
      } else {
        this.$message.success(res.message);
        this.getGiftCodeList();
      }
    },
  },
};
</script>

<style >
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
  overflow: hidden;
}
.filter-item-upload {
  display: inline-block;
  margin: 0px 0px 0px 0px;
  transform: translateY(14px);
}
.el-upload--text {
  width: 80px;
  height: 35px;
  border: none;
  margin-top: 10px;
}
</style>
